// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__OZreS"};